import React, { useState } from 'react'
import { Redirect, Route, Switch, useHistory, RouteProps } from 'react-router-dom'
import { ConsultarStore } from './ConsultarStore'
import { ConsultarContainer } from './ConsultarContainer'
import { CfcModel } from '../../../components/models/Models'
import Login from './login/Login'
import { Button } from 'antd'
import { homePath } from '../../../App'

export const ConsultarRoutes = () => {
  const history = useHistory()

  return (
    <>
      <div style={{ textAlign: 'right', paddingRight: '50px', paddingTop: '10px' }}>
        <Button
          onClick={() => {
            history.push(homePath)
          }}
        >
          Voltar para o início
        </Button>
      </div>

      <ConsultarStore.Provider>
        <Switch>
          <PrivateRoute
            exact
            path={`${homePath}/consultar`}
            redirectTo={`${homePath}/consultar/login`}
            component={ConsultarContainer}
          />

          <Route exact path={`${homePath}/consultar/login`} component={Login} />
        </Switch>
      </ConsultarStore.Provider>
    </>
  )
}

const PrivateRoute = ({ redirectTo, ...props }: { redirectTo: string } & RouteProps) => {
  const { cfcOrigem } = ConsultarStore.useState()
  if (!cfcOrigem) return <Redirect to={redirectTo} />
  const { id, cnpj, fantasia, municipio } = cfcOrigem as CfcModel
  if (id && cnpj && fantasia && municipio) return <Route {...props} />
  return <Redirect to={redirectTo} />
}
